var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from "react";
import { get } from "lodash";
import client, { Query, pagination } from "@irati/utils/services/apollo";
import dealRedemptionQuery, { redemptionListQueryKey } from "../../services/queries/dealRedemptions";
export var query = dealRedemptionQuery;
export function getRedemptionList(apollo) {
    var deals = get(apollo, "data[" + redemptionListQueryKey + "]", {});
    var _a = deals.results, results = _a === void 0 ? [] : _a, cursor = deals.cursor, limit = deals.limit, hasMore = deals.hasMore;
    return {
        results: results,
        limit: limit,
        cursor: cursor,
        hasMore: hasMore
    };
}
export function removeFromRedemptionList(redemption, variables) {
    var _a;
    var data = client.readQuery({ query: query, variables: variables });
    if (data) {
        var redemptions = data.redemptions;
        var newRedemptionList = redemptions.results.filter(function (t) {
            return t.uuid !== redemption.uuid;
        });
        client.writeQuery({
            query: query,
            variables: variables,
            data: (_a = {},
                _a[redemptionListQueryKey] = __assign(__assign({}, redemptions), { results: newRedemptionList }),
                _a)
        });
    }
}
var DealRedemptionListQuery = /** @class */ (function (_super) {
    __extends(DealRedemptionListQuery, _super);
    function DealRedemptionListQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DealRedemptionListQuery.prototype.render = function () {
        var _a = this.props, children = _a.children, props = __rest(_a, ["children"]);
        return (React.createElement(Query, __assign({}, props, { query: query }), function (apollo) {
            var nextPage = function (nextPageVariables) { return pagination({ query: query, variables: nextPageVariables }, apollo); };
            return children(__assign(__assign({}, apollo), { nextPage: nextPage }));
        }));
    };
    return DealRedemptionListQuery;
}(PureComponent));
export default DealRedemptionListQuery;
